<app-profile-slide-in-modal
  modalTitle="Help Desk"
  [slideOpen]="true"
  (action)="closeModal()"
>
  <div class="page__container flex flex-col items-center pb-8 px-4">
      <!-- Call Button -->
      <a
        href="tel:+2347047002646"
        class="mt-6 w-full max-w-xs flex flex-col items-center justify-center gap-3 rounded-xl bg-white p-6 shadow-md hover:shadow-lg hover:bg-gray-50 transition-all duration-200 border border-gray-100"
      >
        <div class="flex h-14 w-14 items-center justify-center rounded-full bg-mango-crayolaGold">
          <img src="/assets/images/svgs/call.svg" class="h-7 w-7" alt="Call" />
        </div>
        <span class="text-sm font-semibold text-mango-grey">Call Us</span>
      </a>

      <!-- WhatsApp Button -->
      <a
        href="https://wa.me/2347047002646"
        target="_blank"
        class="mt-4 w-full max-w-xs flex flex-col items-center justify-center gap-3 rounded-xl bg-white p-6 shadow-md hover:shadow-lg hover:bg-gray-50 transition-all duration-200 border border-gray-100"
      >
        <div class="flex h-14 w-14 items-center justify-center rounded-full bg-mango-pineGreen">
          <img src="/assets/images/svgs/whatsapp-white-icon.svg" class="h-7 w-7" alt="WhatsApp" />
        </div>
        <span class="text-sm font-semibold text-mango-grey">WhatsApp</span>
      </a>
   
    <div class="mt-8 text-center">
      <p class="text-xs text-gray-500">Our support team operates during business hours: 9:00 AM to 5:00 PM, Monday to Friday.</p>
    </div>
  </div>
</app-profile-slide-in-modal>
